// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__2m7wc","notes":"Notes_notes__11PQz","note":"Notes_note__KZYbs","markdown":"Notes_markdown__3cw8u"};